import { useCallback, useState } from 'react'
import { apiGet } from '../../../../generic/Api_Functions'

// Story 100 (S99, RN46/DN-10/DN-13): the widget's list is INSTALLATION-WIDE -- no device or
// technology filter anywhere, regardless of the device the widget happens to be shown on.
//
// Contract (convergence, lote 17): `mos/externalJob/pendingDispatch` and `mos/externalJob/dispatched`
// are real GET endpoints, server-side paginated exactly like `returned` (`page`/`size` query
// params, responding with a Spring `Page`: `{ content, totalElements }`). Neither population has
// its own paging control in this widget (unlike `returned`, S104) -- no scenario in this batch
// exercises paging through them -- so this hook asks for a page large enough to cover the
// installation in practice (same "fetch all" technique as the existing `ALL_INSTANCES_REQUEST`
// pattern, configuration/parts/LoadMachineStorageInstancesDialog.jsx), reading only `content`.
export const PENDING_DISPATCH_RESOURCE = 'mos/externalJob/pendingDispatch'
export const DISPATCHED_RESOURCE = 'mos/externalJob/dispatched'
export const PAGE_SIZE = 1000

const useExternalJobTrips = () => {
  const [pendingDispatch, setPendingDispatch] = useState([])
  const [dispatched, setDispatched] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const reload = useCallback(async () => {
    setLoading(true)
    try {
      const [pendingPage, dispatchedPage] = await Promise.all([
        apiGet(PENDING_DISPATCH_RESOURCE, { page: 0, size: PAGE_SIZE }),
        apiGet(DISPATCHED_RESOURCE, { page: 0, size: PAGE_SIZE })
      ])
      setPendingDispatch(Array.isArray(pendingPage?.content) ? pendingPage.content : [])
      setDispatched(Array.isArray(dispatchedPage?.content) ? dispatchedPage.content : [])
      setError(null)
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [])

  return { pendingDispatch, dispatched, loading, error, reload }
}

export default useExternalJobTrips
